import e, { useEffect as t } from "react";
import { tip as o } from "../../forms/Tooltip/Tooltip.js";
import "../../../../node_modules/classnames/index.js";
import { componentName as r } from "../../../utils/bem/index.js";
import { t as a } from "../../../i18/index.js";
function i(i) {
  var l = i.fillColor,
    n = i.height,
    s = i.viewBox,
    m = i.width,
    p = i.href,
    c = i.ssoVersion,
    d = i.onClick,
    f = r("k1-button", i.className);
  return t(function () {
    o({
      className: r("k1-button__tooltip"),
      target: "." + r("k1-button"),
      content: a(2 === c ? "topbar.login-with-k1" : "topbar.kaseya-com"),
      options: {
        position: "bottom"
      }
    });
  }, []), e.createElement("a", {
    className: f,
    target: "_blank",
    href: p,
    onClick: d
  }, e.createElement("svg", {
    width: m,
    height: n,
    viewBox: s,
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, e.createElement("defs", null, e.createElement("filter", {
    colorInterpolationFilters: "auto",
    id: "filter-1"
  }, e.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 1.000000 0"
  }))), e.createElement("g", {
    id: "Design-Kit",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, e.createElement("g", {
    id: "Header",
    transform: "translate(-1541.000000, -494.000000)"
  }, e.createElement("g", {
    id: "Frames/ITG-Purple-Theme/-Header-Copy-2",
    transform: "translate(148.000000, 482.000000)"
  }, e.createElement("g", {
    id: "Group-Copy",
    transform: "translate(1393.000000, 12.000000)"
  }, e.createElement("g", {
    className: "it-complete-launcher-path",
    transform: "translate(4.000000, 4.000000)",
    id: "Group-3",
    fill: l
  }, e.createElement("path", {
    d: "M22.72,0 C23.42384,0 24,0.57616 24,1.28 L24,22.72 C24,23.424 23.42384,24 22.72,24 L1.28,24 C0.576,24 0,23.424 0,22.72 L0,1.28 C0,0.57616 0.576,0 1.28,0 L22.72,0 Z M11.084224,6.87136 L7.837184,6.87136 L4.433664,9.63296 L4.433664,10.19392 L7.837184,10.19392 L7.837184,17.18368 L11.084224,17.18368 L11.084224,14.30752 L9.329984,12.3464 L11.084224,10.14 L11.084224,6.87136 Z M18.926416,6.81624 L14.896656,6.81624 L10.521296,12.3188 L12.656656,14.70584 L14.855536,17.18376 L18.926416,17.12872 L14.443216,11.97256 L18.926416,6.81624 Z",
    id: "Combined-Shape"
  }))))))));
}
i.displayName = "K1Button", i.defaultProps = {
  fillColor: "#FFF",
  height: "32",
  viewBox: "0 0 32 32",
  width: "32",
  href: "https://www.kaseya.com"
};
export { i as K1Button };